import Row from 'react-bootstrap/Row';
import FMCoverageArea from './FMCoverageArea.js';


function FMCoverageAreas({ fmCoverageAreas, enableHeader = true }) {

	if(!fmCoverageAreas) {
		return null;
	}

	let cards = [];

	fmCoverageAreas.forEach(function(fmCoverageArea) {
		cards.push(<FMCoverageArea
			key={fmCoverageArea.locationSubdomain}
			lat={fmCoverageArea.lat}
			lng={fmCoverageArea.lng}
			locationBlurb={fmCoverageArea.locationBlurb}
			locationName={fmCoverageArea.locationName}
			locationSubdomain={fmCoverageArea.locationSubdomain}
		/>);
	});

	return <div>
		{!!enableHeader && <h3>FloodMapper - FloodNav</h3>}
		<Row className="justify-content-md-center">
			{cards}
		</Row>
	</div>;
}


export default FMCoverageAreas;